export const HTTP_METHODS = ["ALL", "GET", "POST", "PUT", "DELETE"];

export const ROWS_PER_PAGE_OPTIONS = [
  { label: "10", value: "10" },
  { label: "20", value: "20" },
  { label: "50", value: "50" },
];

export const REQUEST_SUB_TABS = [
  { value: "headers", label: "Headers" },
  { value: "parameters", label: "Parameters" },
  { value: "curl", label: "cURL" },
];

export const DETAIL_TABS = [
  { value: "request", label: "Request" },
  { value: "responses", label: "Response(s)" },
  { value: "examples", label: "Example(s)" },
  { value: "guides", label: "Related Guide(s)" },
];
